<template>
    <iframe
        :src="url"
        style="position:fixed; top:0; left:0; bottom:0; right:0; width:100%;
        height:100%; border:none; margin:0; padding:0; overflow:hidden; z-index:999999;"
    ></iframe>
</template>

<script>
    export default {
        computed: {
            url() {
                const paths = {
                    '/primulbonussport': 'https://d1h48zg8ujzx92.cloudfront.net/primulbonussport/index.html',
                    '/primulbonussportz': 'https://d1h48zg8ujzx92.cloudfront.net/primulbonussportz/index.html',
                    '/primulbonuscasinoz': 'https://d1h48zg8ujzx92.cloudfront.net/primulbonuscasinoz/index.html\n',
                };

                return paths[this.$route.path];
            },
        },
    };
</script>
